import React from "react";
import { 
  Zap, 
  Layers, 
  Mic, 
  Terminal, 
  Fingerprint, 
  Clock,
  Link2,
  Star,
  Cpu
} from "lucide-react";
import { useLanguage } from "@/i18n";

const featureIcons = [Zap, Layers, Mic, Terminal, Fingerprint, Clock, Link2, Star, Cpu];
const featureColors = [
  "text-yellow-400",
  "text-primary",
  "text-green-400",
  "text-secondary",
  "text-red-400",
  "text-orange-400",
  "text-accent",
  "text-amber-400",
  "text-gray-400"
];

const FeaturesSection = () => {
  const { t } = useLanguage();
  const featureItems = t('features.items');

  return (
    <section id="features" className="py-20 sm:py-28 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            {t('features.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground">
            {t('features.title')}{" "}
            <span className="text-gradient">{t('features.titleHighlight')}</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            {t('features.description')}
          </p>
        </div>

        {/* Features grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureItems.map((feature, index) => {
            const Icon = featureIcons[index];
            const color = featureColors[index];
            return (
              <div
                key={index}
                className="group relative glass-card rounded-2xl p-6 sm:p-8 hover:border-primary/30 transition-all duration-300"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <Icon className={`w-6 h-6 ${color}`} />
                </div>
                
                {/* Content */}
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {feature.description}
                </p>
                
                {/* Hover glow */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
